(function(){
	"use strict";

	angular
		.module('pwc.directives')
		.directive('customStyles', customStyles);

	customStyles.$inject = ['UserService', 'lodash', '$log'];

	function customStyles(UserService, lodash, $log){
		return {
			restrict : 'A',
			link : function(scope, element, attr){
				var style = angular.element('<style></style>');
				element.append(style);
				scope.$watch(
					function(){ return UserService.$localStorage.theme; },
					function(){
						var themeSettings = UserService.$localStorage.theme;
						var css = '';
						if (lodash.get(themeSettings, 'forms.labelOpacity')){
							css += 'md-input-container label { color:rgba(0, 0, 0, ' + (lodash.get(themeSettings, 'forms.labelOpacity') / 100) + ') !important; }';
						}
						if (lodash.get(themeSettings, 'forms.boldInputs') === false){
							css += 'md-input-container .md-input, md-input-container.md-default-theme .md-input, .md-select-value span, .appellation { font-weight:normal !important; }';
						}
						if (lodash.get(themeSettings, 'dataGrid.bold')){
							css += '.data-table { font-weight:bold !important; }';
						}
						if (lodash.get(themeSettings, 'dataGrid.fontSize') > 0){
							css += '.data-table { font-size:' + lodash.get(themeSettings, 'dataGrid.fontSize') + 'px !important; }';
						}
						style.html(css);
					},
					true
				);
			}
		};
	}

})();
